import { CheckCircleFilled, ExclamationCircleOutlined } from "@/icons"

import styles from "./OverviewStepsAdr.module.scss"

import type { IconStepProps } from "."

export const IconStep = (props: IconStepProps) => {
  if (props.status === "error")
    return <ExclamationCircleOutlined className={styles.iconError} />

  if (props.status === "blocked")
    return <CheckCircleFilled className={styles.iconBlocked} />

  const d = "M5 1a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"

  return (
    <svg width="10" height="10" fill="none">
      <path d={d} fill="#FAFAFA" stroke="#1890FF" strokeWidth="2" />
    </svg>
  )
}
